export default __webpack_public_path__ + "static/datelabel-dropdown-do-3-dark-2b6cb329fbc5aaa27dc8df3a718e6e8a.png";